import { IAuctionWin, IAuctionWinFromYahoo } from '@/features/auctions/auctionSlice'
import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'

export const getAuctionWins = async (params?: any): Promise<IApiResponse<IList<IAuctionWin>>> => {
	const { data } = await axios.get<IApiResponse<IList<IAuctionWin>>>('/api/auction-management/wins', { params })
	return data
}

export const getAuctionWinsFromYahoo = async (params?: any): Promise<IApiResponse<IList<IAuctionWinFromYahoo>>> => {
	const { data } = await axios.get<IApiResponse<IList<IAuctionWinFromYahoo>>>('/api/auction/successful', { params })
	return data
}